import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.analysis.pending');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

const ACCESS_SESSION_KEY = "cellytics.access";
const ACCESS_SESSION_VALUE = "granted";
const ACCESS_USER = {
    id: "cellytics-access",
    email: "",
    name: "Cellytics NK",
    role: "admin",
};

@Component({
    selector: 'wiz-page-analysis-pending',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.analysis.pending/view.scss */
/* src/app/page.analysis.pending/view.scss: no such file or directory */`],
})
export class PageAnalysisPendingComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        if (!this.hasAccess()) {
            location.href = "/access";
            return;
        }
        this.applyAccessSession();
    }

    private hasAccess() {
        return this.service.auth.check() || window.sessionStorage.getItem(ACCESS_SESSION_KEY) === ACCESS_SESSION_VALUE;
    }

    private applyAccessSession() {
        if (this.service.auth.check()) return;
        this.service.auth.status = true;
        this.service.auth.session = ACCESS_USER;
    }
}

export default PageAnalysisPendingComponent;